const lightTheme = {
  background: "#faf3f3",
  textPrimary: "#1c1f3b",
  textSecundary: "gray",
  primary: "#a7bbc7",
  secundary: "#e1e5ea",
};

export default lightTheme;
